import * as React from 'react';

import { ListContainerProps } from './container';

import CalendarText from '../../contexts/calendar-text';
import { IEvent, IMonth } from '../../interfaces';

import LoadMore from '../load-more';
import ListMonthView from './month.view';

interface IListContainerViewProps {
    filteredEvents: IMonth<IEvent>[];
    loadMoreSideEffect: () => void;
}

/**
 * Wrapper HTML for the list view. Renders each month.
 */
class ListContainerView extends React.PureComponent<ListContainerProps & IListContainerViewProps> {
    render(): React.ReactNode {
        return (
            <CalendarText.Consumer>
                {text => (
                    <div className="ace-cal-list-container grid-col">
                        <section className="ace-cal-list">
                            <div className="ace-cal-list-details">
                                <p className="ace-cal-list-events-indicator h6-style visually-hidden" id="Events_Header">{`${this.props.eventCount} ${this.props.eventCount === 1 ? text.singleEventText : text.pluralEventsText}`}</p>
                            </div>
                            <h2 className="visually-hidden">{text.listViewHeading}</h2>
                            <ul className="stack-lg">
                                {
                                    !!this.props.filteredEvents ? this.props.filteredEvents.map(month => <ListMonthView key={`${month.monthMoment.month()}_${month.monthMoment.year()}`} monthData={month} selectedFromMiniCalendar={this.props.selectedFromMiniCalendar} dateSelectedFromMiniCalendar={this.props.dateSelectedFromMiniCalendar} currentScrolledDate={this.props.currentScrolledDate} />) : null
                                }
                            </ul>
                            <LoadMore loadMoreSideEffect={this.props.loadMoreSideEffect} />
                        </section>
                    </div>
                )}
            </CalendarText.Consumer>
        )
    }
}

export default ListContainerView;
